/*
* @Descripttion:
* @Date: 2020-04-27 19:38:47
* @LastEditors: huyutao
* @LastEditTime: 2020-11-11 09:26:15
*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import http from "./lib/js/axios.js";

import api from "./Interface/api/index.js";
import {post} from './Interface/axios'
import './public/css/common.css'



import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)

Vue.prototype.$axios = axios;
Vue.prototype.$HTTP = http;
Vue.prototype.$api = api;
Vue.prototype.$post = post
import XHeader from 'vux/src/components/x-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import Search from 'vux/src/components/search/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import Datetime from 'vux/src/components/datetime/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import Icon from 'vux/src/components/icon/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'





Vue.config.productionTip = false;

Vue.component("x-popup-radio", PopupRadio);
Vue.component("x-icon", Icon);
Vue.component("x-popup", Popup);
Vue.component("x-swiper", Swiper);
Vue.component("x-inline-loading", InlineLoading);
Vue.component("x-header", XHeader);
Vue.component("x-group", Group);
Vue.component("x-cell", Cell);
Vue.component("x-cell-form-preview", CellFormPreview);
Vue.component("x-flexbox", Flexbox);
Vue.component("x-flexbox-item", FlexboxItem);
Vue.component("x-button", XButton);
Vue.component("x-button-tab", ButtonTab);
Vue.component("x-button-tab-item", ButtonTabItem);
Vue.component("x-scroller", Scroller);
Vue.component("x-load-more", LoadMore);
Vue.component("x-tab", Tab);
Vue.component("x-tab-item", TabItem);
Vue.component("x-inline-x-number", InlineXNumber);
Vue.component("x-checker", Checker);
Vue.component("x-checker-item", CheckerItem);
Vue.component("x-rater", Rater);
Vue.component("x-search", Search);
Vue.component("x-input", XInput);
Vue.component("x-textarea", XTextarea);
Vue.component("x-popup-picker", PopupPicker);
Vue.component("x-datetime", Datetime);
Vue.component("x-form-preview", FormPreview);
Vue.use(ToastPlugin);
Vue.use(ConfirmPlugin);
Vue.use(AlertPlugin);
Vue.use(LoadingPlugin);

new Vue({
el: "#app",
router,
components: { App },
template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js